<template>
  <button 
    type="button" 
    class="btn-plain"
    :class="[
      interview ? 'btn-heart-fill' : 'btn-heart',
      fromSearchBar ? 'custom-size' : ''
    ]"
    :disabled="toggledisabledInt"
  >
    <svg
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="interview-svg"
      :class="{ 'interview-active': interview }"
    >
      <path d="M29.9984 11.1502V6.16179C29.9984 4.26886 28.4604 2.72662 26.5674 2.72662H24.8647V4.7841V5.6843V6.51253C24.8647 7.5013 24.0619 8.30388 23.0731 8.30388H19.9252C18.9364 8.30388 18.1337 7.5013 18.1337 6.51253V5.68424V4.7841V2.74249V2.73629V2.72656H11.8673V4.78404V5.68424V6.51247C11.8673 7.50124 11.0602 8.30382 10.0715 8.30382H6.92789C5.93912 8.30382 5.13205 7.50124 5.13205 6.51247V5.68424V4.7841V2.72656H3.43352C1.5406 2.72656 0.00261382 4.2688 0.00261382 6.16173V11.1501H0V27.359C0 29.4327 1.6871 31.1201 3.76099 31.1201H26.2384C28.312 31.1201 29.9994 29.4327 29.9994 27.3591V11.1502H29.9984ZM2.95792 11.5617H2.96029V10.9298H27.0407V11.5617H27.0414V27.359C27.0414 27.8017 26.6812 28.1621 26.2384 28.1621H3.76099C3.31791 28.1621 2.95792 27.8016 2.95792 27.359V11.5617Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M9.90056 14.0111V14V13.9902H6.24023V17.6503H9.90056V14.0111Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M16.8299 13.9902H13.1699V17.6503H16.8299V13.9902Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M20.1016 17.6406V17.6503H23.7619V13.9902H20.1016V17.6296V17.6406Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M9.90056 20.6322V20.6211V20.6113H6.24023V24.2716H9.90056V20.6322Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M16.8299 20.6113H13.1699V24.2716H16.8299V20.6113Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M20.1016 24.2716H23.7619V20.6113H20.1016V24.2508V24.2619V24.2716Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M6.92845 7.0395H10.072C10.3637 7.0395 10.6001 6.80723 10.6001 6.51563V5.6874V4.78726V2.72972V1.63105C10.6001 0.735165 9.86504 0 8.96508 0H8.03545C7.13549 0 6.40039 0.735165 6.40039 1.63105V2.72972V4.7872V5.6874V6.51563C6.40039 6.80723 6.63685 7.0395 6.92845 7.0395Z" :fill="interview ? '#ff0000' : 'black'"/>
      <path d="M19.9264 7.0395H23.0743C23.3616 7.0395 23.5981 6.80723 23.5981 6.51563V5.6874V4.78726V2.72972V1.63105C23.5981 0.735165 22.863 0 21.9673 0H21.0334C20.1375 0 19.4023 0.735165 19.4023 1.63105V2.72972V4.7872V5.6874V6.51563C19.4023 6.80723 19.6391 7.0395 19.9264 7.0395Z" :fill="interview ? '#ff0000' : 'black'"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'Interview',
  props: ['interview', 'toggledisabledInt','fromSearchBar']
};
</script>
<style scoped>
.interview-svg {
  transition: all 0.2s ease;
}

.custom-size .interview-svg {
  width: 31px;
  height: 33px;
}

.prof-head-left .btn-heart:hover .interview-svg path,
.one-right .btn-heart:hover .interview-svg path {
  fill: #aba2a2;
}

.prof-head-left .btn-heart-fill:hover .interview-svg path,
.one-right .btn-heart-fill:hover .interview-svg path {
  fill: #bf3404;
}
</style>

